import script from "./UiItemListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UiItemListCard.vue?vue&type=script&setup=true&lang=js"

import "./UiItemListCard.vue?vue&type=style&index=0&id=c2a84ef6&lang=css"

const __exports__ = script;

export default __exports__